import axios from 'axios';

export const HTTPDSP = axios.create({
  baseURL: `https://nashoof.sd.zain.com/DSPAPIs/APIs/`
})
